export default {
    userData(state){
        return state.userData;
    },

    users(state){
        return state.users;
    }
};